export default function constructNodeFromString (stringElement: string): HTMLElement {
    const div = document.createElement('div')

    div.innerHTML = stringElement.trim()

    return div.firstChild as HTMLElement
}
